import { Component, ElementRef, EventEmitter, Input, OnInit, OnChanges, Output } from '@angular/core';
import {ProductModel} from '../models/product.model';

@Component({
  selector: 'app-accessory-details-details',
  template: `
    <div>
      <div class="detailsHeader">{{this.model.type}} Accessories</div>
      <div class="detailsSubHeader">{{this.model.title}} Accessories</div>
      <span [ngClass]="overviewClass" (click)="this.getClass('overview')">Overview</span><span [ngClass]="benefitsClass" (click)="this.getClass('benandfeat')">Benefits & Features</span><span [ngClass]="resourcesClass" (click)="this.getClass('resources')">Resources</span>
      <div class="detailsText" *ngIf="showOverview">{{this.model.overview}}</div>
      <div class="detailsText" *ngIf="showBenefitsFeatures">{{this.model.benefitsFeatures}}</div>
      <div *ngIf="showResources"></div>
    </div>
  
  `,
  styles: [
    `
      .detailsHeader{
        color: #A50034;	
        font-family: "LGEIBold";
        font-size: 40px;	
        text-align: left;
      }

      .detailsSubHeader{
        color: #4A4A4A;	
        font-family: 'LGEIRegular';
        font-size: 32px;	
        text-align: left;
      }

      .detailButtonSelected {
        width: 33%;
        background-color: #A50034;
        color: #FFFFFF;	
        font-family: 'LGEIRegular';
        font-size: 18px;	
        font-weight: 500;	
        text-align: center;
        border: 1px solid #A50034;
        cursor: pointer;
        display: inline-block;
        line-height: 3;
      }

      .detailButtonUnselected {
        width: 33%;
        background-color: #FFF;
        color: #A50034;	
        font-family: 'LGEIRegular';
        font-size: 18px;	
        font-weight: 500;	
        text-align: center;
        border: 1px solid #A50034;
        cursor: pointer;
        display: inline-block;
        line-height: 3;
      }

      .detailsText{
        color: #4A4A4A;	
        font-family: 'LGEIRegular';
        font-size: 20.1px;
        line-height: 2;
      }
    
    `
  ]
})
export class AccessoryDetailsDetailsComponent implements OnChanges {
  @Input() model: ProductModel;
  overviewClass: string = 'detailButtonSelected';
  benefitsClass: string = 'detailButtonUnselected';
  resourcesClass: string = 'detailButtonUnselected'
  showOverview: Boolean = true;
  showBenefitsFeatures: Boolean = false;
  showResources: Boolean = false;

  ngOnChanges(){
    this.overviewClass = 'detailButtonSelected';
    this.benefitsClass = 'detailButtonUnselected';
    this.resourcesClass = 'detailButtonUnselected';
    this.showOverview = true;
    this.showBenefitsFeatures = false;
    this.showResources = false;
  }

  getClass(selected: string) {
    if (selected === "benandfeat"){
      this.overviewClass = 'detailButtonUnselected';
      this.benefitsClass = 'detailButtonSelected';
      this.resourcesClass = 'detailButtonUnselected';
      this.showOverview = false;
      this.showBenefitsFeatures = true;
      this.showResources = false;
    }
    else if (selected === "resources"){
      this.overviewClass = 'detailButtonUnselected';
      this.benefitsClass = 'detailButtonUnselected';
      this.resourcesClass = 'detailButtonSelected';
      this.showOverview = false;
      this.showBenefitsFeatures = false;
      this.showResources = true;
    }
    else {
      this.overviewClass = 'detailButtonSelected';
      this.benefitsClass = 'detailButtonUnselected';
      this.resourcesClass = 'detailButtonUnselected';
      this.showOverview = true;
      this.showBenefitsFeatures = false;
      this.showResources = false;
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/components/accessory-details-details.component.ts